import { Checkbox, Tabs } from "antd";
import { React, useEffect, useState } from "react";
import AttributeConfigureOptions from "./AttrsOptions";
import { useSelector } from "react-redux";
const { TabPane } = Tabs;
const AttributeConfigureHeader = ({
  TaggingOn,
  optionValues,
  editPanel,
  setXaxisProp,
  setBreakdownProp,
}) => {
  const [currTaggingState, setCurrTaggingState] = useState(null);
  const axisPanelAtt = useSelector(
    (state) => state.GraphConfig.widgetGraphConfig
  );
  const [selectedTag, setSelectedTag] = useState(null);

  let currIndexBreakdown = editPanel?.breakdown_index;

  // to give default selected tagging on to AttrsOptions
  useEffect(() => {
    if (editPanel?.series === "x_axis") {
      if (editPanel?.chart_type === "sankey") {
        let defaultKey = "start";
        setCurrTaggingState(TaggingOn[defaultKey][0]);
      } else {
        if (
          axisPanelAtt?.x_axis?.config_filters?.[0]?.attribute.endsWith("end")
        ) {
          setSelectedTag("end");
          setCurrTaggingState(TaggingOn["end"][0]);
        } else if (
          axisPanelAtt?.x_axis?.config_filters?.[0]?.attribute.endsWith("start")
        ) {
          setSelectedTag("start");
          setCurrTaggingState(TaggingOn["start"][0]);
        } else {
          setSelectedTag("notJourneyAttribute");
          setCurrTaggingState("notJourneyAttribute");
        }
      }
    } else if (editPanel?.series === "breakdown") {
      if (
        axisPanelAtt?.breakdown_by?.[
          currIndexBreakdown
        ]?.config_filters?.[0]?.attribute.endsWith("end")
      ) {
        setSelectedTag("end");
        setCurrTaggingState(TaggingOn["end"][0]);
      } else if (
        axisPanelAtt?.breakdown_by?.[
          currIndexBreakdown
        ]?.config_filters?.[0]?.attribute.endsWith("start")
      ) {
        setSelectedTag("start");
        setCurrTaggingState(TaggingOn["start"][0]);
      }
    }
  }, [TaggingOn, axisPanelAtt]);

  // taggingOn change in case of ( sankey && x_axis )
  const multipleTaggingClicked = (key) => {
    if (key) {
      const attributeName = TaggingOn[key] ? TaggingOn[key][0] : key;
      setCurrTaggingState(attributeName);
    }
  };

  // taggingOn change in other cases
  const handleChange = (e) => {
    setSelectedTag(e.target.checked ? e.target.value : null);
    if (e.target.value) {
      const attributeName = TaggingOn[e.target.value]
        ? TaggingOn[e.target.value][0]
        : e.target.value;
      setCurrTaggingState(attributeName);
    }
  };
  const isJourney = TaggingOn?.end && TaggingOn?.start ? true : false;
  return (
    <>
      {/* this will render in case of ( sankey && x_axis ) */}
      {isJourney &&
      editPanel?.series === "x_axis" &&
      editPanel?.chart_type === "sankey" ? (
        <>
          <div className="editPanelTab">
            {" "}
            <Tabs
              className=" tabs_widgetMaker_Configure"
              onChange={multipleTaggingClicked}
            >
              <TabPane
                className="widgetMaker_Configure-tabs"
                tab="Start"
                key="start"
              ></TabPane>
              <TabPane
                className="widgetMaker_Configure-tabs"
                tab="End"
                key="end"
              ></TabPane>
            </Tabs>
          </div>
          <AttributeConfigureOptions
            optionValues={optionValues}
            currTaggingState={currTaggingState}
            editPanel={editPanel}
            setXaxisProp={setXaxisProp}
            setBreakdownProp={setBreakdownProp}
          />{" "}
        </>
      ) : isJourney ? (
        <div>
          <div style={{ marginLeft: "2rem" }}>Tagging On:</div>
          <div
            style={{
              marginLeft: "2rem",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Checkbox
              value="start"
              checked={selectedTag === "start"}
              onChange={handleChange}
            >
              Start
            </Checkbox>
            <Checkbox
              value="end"
              checked={selectedTag === "end"}
              onChange={handleChange}
            >
              End
            </Checkbox>
          </div>
          <AttributeConfigureOptions
            optionValues={optionValues}
            currTaggingState={currTaggingState}
            editPanel={editPanel}
            setXaxisProp={setXaxisProp}
            setBreakdownProp={setBreakdownProp}
          />
        </div>
      ) : TaggingOn ? (
        <AttributeConfigureOptions
          optionValues={optionValues}
          currTaggingState={currTaggingState}
          editPanel={editPanel}
          setXaxisProp={setXaxisProp}
          setBreakdownProp={setBreakdownProp}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default AttributeConfigureHeader;
